import { IAction } from '../../state/types';
import * as actInterf from './types';
import * as actionTypes from './constants';

const defaultState: actInterf.IApiState = {
    businesses: [],
    selectedServices: [],
    businessBookings: [],
    selectedBusiness: null,
};

const appReducer = (
    state: actInterf.IApiState = defaultState,
    action: {} | actInterf.IApiState | IAction
) => {
    switch ((action as IAction).type) {
        case actionTypes.STORE_BUSINESSES: {
            return { ...state, businesses: (action as actInterf.IBusinesssAction).businesses };
        }
        case actionTypes.TOGGLE_SELECTED_BUSINESS_SERVICE: {
            const selectedBusiness: actInterf.IBusiness = (action as actInterf.IToggleBusinessService).business;
            const selectedService: actInterf.IService = (action as actInterf.IToggleBusinessService).service;
            const _selectedServices: actInterf.IService[] = state.selectedServices;

            const handleSelectedBusinesses = (service: actInterf.IService) => {
                if (service.isSelected) {
                    _selectedServices.push(service);
                } else {
                    _selectedServices.splice(_selectedServices.indexOf(service), 1);
                }
            }

            const _businesses = state.businesses.map((business) => {
                if (business.id === selectedBusiness.id) {
                    selectedBusiness.services?.map(service => {
                        if (service.id === selectedService.id) {
                            service.isSelected = service.isSelected === undefined ? true : !service.isSelected;
                            handleSelectedBusinesses(service);
                        }
                        return service;
                    });
                }
                return business;
            });

            return { ...state, businesses: _businesses, selectedServices: _selectedServices };
        }
        case actionTypes.CLEAR_SELECTED_BUSINESS_SERVICES: {
            return { ...state, selectedServices: [] };
        }
        case actionTypes.STORE_SELECTED_BUSINESS: {
            return {
                ...state,
                selectedBusiness: (action as actInterf.IStoreSelectedBusiness).business,
                businessBookings: (action as actInterf.IStoreSelectedBusiness).bookings
            };
        }
        default: {
            return state;
        }
    }
};

export default appReducer;
